import { TProDirectory, TProDirectoryRevision } from '@onesource/schemas';

export type DataShape = TProDirectoryRevision['data'];

export const FIELD_LABELS: Array<{ key: keyof DataShape; label: string }> = [
  { key: 'bio', label: 'Bio' },
  { key: 'profession', label: 'Profession' },
  { key: 'other_profession', label: 'Other Profession' },
  { key: 'company_name', label: 'Company Name' },
  { key: 'company_email', label: 'Company Email' },
  { key: 'professional_website', label: 'Professional Website' },
  { key: 'offerings', label: 'Offerings' },
  { key: 'teaching_format', label: 'Teaching Format' },
  { key: 'expertise', label: 'Expertise' },
  { key: 'languages_taught', label: 'Languages Taught' },
  { key: 'title', label: 'Title' },
  { key: 'phone', label: 'Phone' },
  { key: 'business_street', label: 'Business Street' },
  { key: 'business_country_id', label: 'Business Country' },
  { key: 'business_state_id', label: 'Business State' },
  { key: 'business_city_id', label: 'Business City' },
  { key: 'socials', label: 'Socials' },
];

export const statusColor = (status: TProDirectoryRevision['status']) => {
  if (status === 'approved') {
    return 'success';
  }
  if (status === 'rejected') {
    return 'error';
  }
  return 'warning';
};

export const approvedToDataShape = (td: TProDirectory | null): DataShape | null => {
  if (!td) {
    return null;
  }
  return {
    bio: td.bio ?? null,
    profession: td.profession ?? null,
    other_profession: td.otherProfession ?? null,
    company_name: td.companyName ?? null,
    company_email: td.companyEmail ?? null,
    professional_website: td.professionalWebsite ?? null,
    offerings: td.offerings ?? null,
    teaching_format: td.teachingFormat ?? null,
    expertise: td.expertise ?? null,
    languages_taught: td.languagesTaught ?? null,
    casual_image: td.casualImage ?? null,
    landscape_image: td.landscapeImage ?? null,
    title: td.title ?? null,
    phone: td.phone ?? null,
    business_street: td.businessStreet ?? null,
    business_country_id: td.businessCountryId ?? null,
    business_state_id: td.businessStateId ?? null,
    business_city_id: td.businessCityId ?? null,
    socials: td.socials ?? null,
  };
};
